/**
 * gordon-0915-froala-toolbar-kebab-ur-emoji-clipped-bullet-missing (Gordon,
 * 2026-09-15, web-dev /builder/4908, Wheel Settings > Description): "the
 * kebab (more-options) button must sit in the UPPER-RIGHT corner of the
 * toolbar, not inline after italic."
 *
 * MEASURED live (web-dev.iyuga.net/builder/6346, Description field, 1440px):
 * the toolbar's only `.fr-btn-grp` is `float: left` and sized to its own
 * content (193px inside a 362px-wide toolbar) — the `moreMisc` toggle
 * (`data-cmd="moreMisc"`) is simply the LAST button inside that left-floated
 * group, so it sits wherever the last visible real button happens to end,
 * with the toolbar's remaining width left empty to its right. `index.scss`
 * has a `.fr-btn-grp:nth-child(2) { margin-left: auto }` rule that looks like
 * it should push a second group to the right edge, but it can't: that rule
 * only does anything in a flex/grid container, and `.fr-toolbar`'s own
 * `display: flex` was deliberately removed (see the comment above it) to stop
 * the toolbar wrapping onto extra rows. There is also only ever ONE
 * `.fr-btn-grp` at a time here (confirmed live), so `:nth-child(2)` would
 * never match regardless.
 *
 * FIX: position the kebab directly, independent of Froala's own grouping.
 * `.fr-toolbar` already computes `position: relative` (Froala's own core
 * CSS), so an `absolute` kebab pins to the toolbar's own box — the literal
 * "upper-right corner" Gordon asked for — regardless of how many real buttons
 * precede it, how many `.fr-btn-grp` containers Froala renders, or whether
 * flex is enabled. `top: 50%` + `translateY(-50%)` centers it on the row's
 * height without hardcoding a button-height constant that would drift the
 * next time the row's own height changes (see index.scss's touch-target
 * history in emojiToolbarButton.js for exactly that kind of drift).
 */

/** `data-cmd` Froala stamps on the toolbar overflow ("more"/kebab) toggle. */
export const TOOLBAR_KEBAB_CMD = "moreMisc";

/**
 * Stylesheet injected once into `<head>` by FroalaTextEditor. Applies on
 * every surface that renders the shared editor and passes a grouped
 * (`moreMisc`) `toolbarButtons` config, so the fix cannot be one-caller deep.
 */
export const TOOLBAR_KEBAB_POSITION_CSS = `
        .fr-toolbar button.fr-command[data-cmd="${TOOLBAR_KEBAB_CMD}"] {
          position: absolute !important;
          top: 50% !important;
          right: 4px !important;
          left: auto !important;
          transform: translateY(-50%) !important;
          margin: 0 !important;
        }
`;
